import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

/**
 * SimpleDialog - a generic modal dialog for consistent UI across the app.
 *
 * Props:
 * - open: boolean - whether the dialog is open
 * - onClose: () => void - called when dialog should close
 * - title: React.ReactNode - dialog title
 * - children: React.ReactNode - dialog content
 * - actions: React.ReactNode - dialog actions (buttons)
 *
 * Example usage:
 * <SimpleDialog
 *   open={open}
 *   onClose={handleClose}
 *   title="Confirm Action"
 *   actions={<><Button onClick={handleClose}>Cancel</Button><Button onClick={onConfirm}>OK</Button></>}
 * >
 *   <Typography>Are you sure?</Typography>
 * </SimpleDialog>
 */
const SimpleDialog = ({
  open,
  onClose,
  title,
  children,
  actions,
}: {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  actions: React.ReactNode;
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700, textAlign: 'center', pb: 0 }}>{title}</DialogTitle>
    <DialogContent sx={{ textAlign: 'center', pt: 2 }}>{children}</DialogContent>
    <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>{actions}</DialogActions>
  </Dialog>
);

export default SimpleDialog;
